import React, { Component } from "react";
import { Page, PageActions, Layout, Card, FormLayout, TextField } from "@shopify/polaris";
import { toastr } from "../../components/toastr";
import API from "../../API";

class GroupCreate extends Component {
	constructor(props) {
		super(props);
		this.state = { saving: false, form: { name: "" } };
	}

	updateForm(field, value) {
		var formState = this.state.form;
		formState[field] = value;

		this.setState({ form: formState });
	}

	saveForm() {
		this.setState({ saving: true });
		API.post("/api/groups.json", this.state.form)
			.then((result) => {
				this.setState({ saving: false });
				if (result.data.error) {
					return;
				}
				toastr.success("Group created");
				this.props.history.replace("/admin/groups/" + result.data.group.id);
			})
			.catch((error) => {
				this.setState({ saving: false });
				toastr.error(error);
			});
	}

	render() {
		return (
			<Page
				title="Ny grupp"
				backAction={{ content: "Grupper", url: "/admin/groups" }}
				primaryAction={{ content: "Skapa grupp", loading: this.state.saving, onAction: this.saveForm.bind(this) }}
			>
				<Layout>
					<Layout.AnnotatedSection title="Gruppdetaljer" description="Fyll i detaljer om gruppen">
						<Card>
							<Card.Section>
								<FormLayout>
									<TextField label="Namn" value={this.state.form.name} onChange={this.updateForm.bind(this, "name")} />
								</FormLayout>
							</Card.Section>
						</Card>
					</Layout.AnnotatedSection>
				</Layout>
				<PageActions
					primaryAction={{
						content: "Skapa grupp",
						loading: this.state.saving,
						onAction: this.saveForm.bind(this),
					}}
				/>
			</Page>
		);
	}
}

export default GroupCreate;
